<app-navbar></app-navbar>

<div class="container mt-2 mb-2">
  <div class="marquee-container" style="display: flex; align-items: center; border: 1px solid #ddd;">
    <div class="col-md-auto" style="text-align: center; padding: 5px 15px; background-color: #005a63;">
      <h4 style="display: inline; color: #ffffff; font-size: 1.1rem; margin: 0;">Notice:</h4>
    </div>
    <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseleave="this.start();"
      style="padding-top: 5px;" *ngIf="!loadingData">
      <table class="border-0 align-items-center">
        <tbody class="align-items-center" *ngIf="Notices.length ==0">
          <tr>
            <td class="border-0">
              <a class="scroll-text" style="color: white;">No Notices Found</a>
              &nbsp; &nbsp; &nbsp;
            </td>
          </tr>
        </tbody>
        <tbody class="align-items-center" *ngIf="Notices.length !=0">
          <tr>
            <td class="border-0" *ngFor="let data of Notices">
              <a (click)="onNavigate(data.FileLink)" class="scroll-text"
                style="color: white; cursor: pointer;">{{data.EnglishTitle}}</a>
              &nbsp; &nbsp; &nbsp;
            </td>
          </tr>
        </tbody>
      </table>
    </marquee>
    <div class="placeholder-glow w-100" style="padding: 5px 15px;" *ngIf="loadingData">
      <span class="placeholder col-8" style="height: 20px;"></span>
    </div>
  </div>
</div>

<section class="about-area">
  <div class="container">
    <div class="row parent">
      <div class="col-lg-8 col-md-12 child">
        <div id="carouselExampleCaptions" class="carousel slide pb-70" data-bs-ride="carousel"
          *ngIf="slides.length != 0">
          <div class="carousel-indicators">
            <button *ngFor="let slide of slides; let i = index" type="button" data-bs-target="#carouselExampleCaptions"
              [attr.data-bs-slide-to]="i" [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null"
              [attr.aria-label]="'Slide ' + (i + 1)"></button>
          </div>
          <div class="carousel-inner" *ngIf="!loadingData">
            <div *ngFor="let slide of slides; let i = index" class="carousel-item main-carousel fist-carousel"
              [class.active]="i === 0">
              <img [src]="slide.ImageLink" class="d-block w-100 h-100 imgH" alt="Slide {{ i + 1 }}" />
              <!-- <div class="carousel-caption d-none d-md-block">
        <p style="color: white">{{ slide.caption }}</p>
      </div> -->
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <div aria-hidden="true" *ngIf="loadingData" class="col-lg-12 col-md-12 child carousel-inner">
          <h5 class="placeholder-glow">
            <span class="placeholder col-12" style="height: 600px; width: 100%"></span>
          </h5>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 child" style="color: white;">
        <div class="widget-area">
          <section class="widget widget_karlson_posts_thumb">
            <h3 class="widget-title" style="color: #ffffff">Notices</h3>
            <article class="item">
              <div class="ticker-wrapper-v-image">
                <ul class="news-ticker-v-image" *ngIf="loadingData">
                  <li style="border: 1px solid #eeeeee; padding: 10px" *ngFor="let i of [1,2,3,4,5]">
                    <div class="placeholder-glow">
                      <span class="placeholder col-12" style="height: 50px;"></span>
                    </div>
                  </li>
                </ul>
                <ul class="news-ticker-v-image" *ngIf="!loadingData && Notices.length == 0">
                  <li style="border: 1px solid #eeeeee; padding: 10px">

                    <div>
                      <div style="
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      ">
                        No Notices Found
                      </div>

                    </div>
                    <div class="clear"></div>
                  </li>

                </ul>
                <ul class="news-ticker-v-image" *ngIf="!loadingData && Notices.length != 0">
                  <li *ngFor="let item of Notices" style="border: 1px solid #eeeeee; padding: 10px">
                    <div class="thumbnail">
                      <div style="border: 1px solid #eeeeee; width: 80px">
                        <div style="background-color: #005a63;" class="text-center">
                          <span style="text-align: center; color: #ffffff">{{
                            item.CreatedDate | date:'dd'
                            }}</span>
                        </div>
                        <div style="background-color: #f2f2f2" class="text-center">
                          <span style="text-align: center; color: #caa545">{{
                            item.CreatedDate | date:'MMM'
                            }}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        ">
                        {{ item.EnglishTitle }}
                      </div>
                      <div style="overflow: auto">
                        <a (click)="onNavigate(item.FileLink)" style="text-decoration: unset; color: #eaeaee">View
                          Notice</a>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </li>
                </ul>
              </div>
            </article>
          </section>
        </div>
      </div>
      <a routerLink="/notice" class="viewAll" style="color: white !important; text-align: right"><i
          class="fa fa-bars"></i> View All</a>
    </div>
  </div>
</section>

<section class="solution-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}' style="margin: 20px 0 20px 0"
  *ngIf="!loadingData">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-12">
        <div class="solution-content">
          <h2>ABOUT PROYASH</h2>
          <p>
            Proyash Chattogram is functioning under the patronization of
            Bangladesh Army since July 2006. Proyash runs similar programs in
            Dhaka, Jassore, Bogura, Rangpur, Savar, Comilla, Sylhet and Ghatail
            area. All the services and facilities are open for all types of
            children with special needs of Bangladesh and other nationalities.
          </p>
        </div>
      </div>
      <div class="col-lg-5 col-md-12">
        <div class="solution-video">
          <a href="https://www.youtube.com/watch?v=ekzAmAQ_wMc" class="video-btn popup-youtube"><i
              class="flaticon-play-button"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="solution-area ptb-100" style="margin: 20px 0 20px 0" *ngIf="loadingData">
  <div class="container placeholder-glow">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-12">
        <div class="solution-content">
          <h2 class="placeholder col-6" style="height: 30px;"></h2>
          <p>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-11"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-10"></span>
            <span class="placeholder col-11"></span>
          </p>
        </div>
      </div>
      <div class="col-lg-5 col-md-12 text-center">
        <span class="placeholder" style="width: 100px; height: 100px; border-radius: 50%;"></span>
      </div>
    </div>
  </div>
</section>

<!-- <section class="blog-area">
    <div class="container">
        <h3 class="widget-title" style="color: #ffffff; text-align: center;">PROYASH NEWS</h3>
        <hr>
        <div class="team-slider owl-carousel owl-theme">
            <div *ngFor="let post of news" class="single-team-box">
                <div class="single-blog-post badgeItem">
                    <span class="badge badge-primary badgeDate">
                        <time class="fullimage cover bg1 date">{{ post.date | date: 'MMMM dd, yyyy' }}</time>
                    </span>
                    <div class="hover-zoom">
                        <a [routerLink]="post.routerLink" routerLinkActive="active"><img [src]="post.image"
                                alt="image"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Our services  -->
<section class="about-area">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Our services
    </h3>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <div id="achievementCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
          <div *ngIf="loadingData" class="row gx-2">
            <div class="col-12 col-sm-6 col-lg-4" *ngFor="let i of [1,2,3]">
              <div class="card" aria-hidden="true">
                <div class="placeholder-glow">
                  <span class="placeholder col-12" style="height: 320px;"></span>
                </div>
                <div class="card-body" style="height: 200px;">
                  <h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>
                  <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                  </p>
                  <a tabindex="-1" class="btn btn-primary disabled placeholder col-6"></a>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-inner" *ngIf="!loadingData">
            <div *ngFor="let group of cardGroups; let i = index" class="carousel-item" [ngClass]="{ active: i === 0 }">
              <div class="row gx-2">
                <div *ngFor="let item of group" class="col-12 col-sm-6 col-lg-4">
                  <!-- Adjusted grid classes -->
                  <div class="card">
                    <div class="hover-zoom">
                      <img [src]="
                                                    item.ShowAttachments[0]
                                                        .FilePath
                                                " style="
                                                    width: 100%;
                                                    height: 320px;
                                                    object-fit: cover;
                                                    transition: opacity 0.9s
                                                            ease,
                                                        transform 0.9s ease;
                                                " class="card-img-top" alt="{{
                                                    item.ContentCategoryName
                                                }}" />
                    </div>
                    <div class="card-body" style="height: 200px;">
                      <h5>{{ item.TitleEn }}</h5>
                      <span [innerHTML]="truncateText(item.DetailsEn,62)"></span>
                      <a [routerLink]="['/services', item.Id]" class="default-btn">Read More<span></span></a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev test_one test_one_pre" type="button" data-bs-target="#newsCarousel"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next test_one test_one_next" type="button" data-bs-target="#newsCarousel"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>

    <div class="text-end" style="padding: 10px 0px">
      <a routerLink="/services" class="default-btn" style="background-color: #020689 !important">
        View All<i class="flaticon-right-arrow"></i></a>
    </div>
  </div>
</section>
<!-- Our services  -->
<!-- Evnets -->
<section class="blog-area news">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Proyash Events
    </h3>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <div id="newsCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3500">
          <div *ngIf="loadingData" class="row gx-2">
            <div class="col-12 col-sm-6 col-lg-4" *ngFor="let i of [1,2,3]">
              <div class="card" aria-hidden="true">
                <div class="placeholder-glow">
                  <span class="placeholder col-12" style="height: 320px;"></span>
                </div>
                <div class="card-body" style="height: 280px;">
                  <h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>
                  <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                  </p>
                  <a tabindex="-1" class="btn btn-primary disabled placeholder col-6"></a>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-inner" *ngIf="!loadingData">
            <div *ngFor="
                                    let group of cardGroupsNews;
                                    let i = index
                                " class="carousel-item" [ngClass]="{ active: i === 0 }">
              <div class="row gx-2">
                <div *ngFor="let item of group" class="col-12 col-sm-6 col-lg-4">
                  <!-- Adjusted grid classes -->
                  <div class="card">
                    <div>
                      <img [src]="
                                                        item.ShowAttachments[0]
                                                            .FilePath
                                                    " style="
                                                        width: 100%;
                                                        height: 320px;
                                                        object-fit: cover;
                                                        transition: opacity 0.9s
                                                                ease,
                                                            transform 0.9s ease;
                                                    " class="card-img-top" alt="{{
                                                        item.ContentCategoryName
                                                    }}" />
                    </div>
                    <div class="card-body" style="
                                                     height: 280px;
                                                ">
                      <h1 class="card-title" style="
                                                        font-size: 25px !important;
                                                    ">
                        {{ item.TitleEn }}
                      </h1>
                      <div class="card-body">
                        <span [innerHTML]="truncateText(item.DetailsEn,72)"></span> <a [routerLink]="[
                  '/news-and-events',
                  item.Id
              ]" class="default-btn">Read More<span></span></a>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev test_one test_one_pre" type="button" data-bs-target="#newsCarousel"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next test_one test_one_next" type="button" data-bs-target="#newsCarousel"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>

    <div class="text-end" style="padding: 10px 0px">
      <a routerLink="/news-and-events" class="default-btn" style="background-color: #020689 !important">
        View All <i class="flaticon-right-arrow"></i></a>
    </div>
  </div>
</section>
<!-- Ends Events -->

<!-- Our Gellary Section Starts -->
<section class="about-area" style="background-color: #005a63; padding: 50px 0;">
  <div class="container">
    <div class="row parent">
      <ng-container *ngIf="loadingData">
        <div class="section-title text-center" style="margin-bottom: 30px;">
          <h3 class="placeholder-glow" style="color: #f8f8f8; font-size: 2rem; font-weight: 600;">
            <span class="placeholder col-3"></span>
          </h3>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-4" *ngFor="let i of [1,2,3]">
              <div class="gallery-item" style="position: relative; border-radius: 10px; overflow: hidden;"
                aria-hidden="true">
                <div class="placeholder-glow">
                  <span class="placeholder col-12" style="height: 250px;"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingData">
        <div class="section-title text-center" style="margin-bottom: 30px;">
          <h3 style="color: #f8f8f8; font-size: 2rem; font-weight: 600;">Our Gallery</h3>
        </div>

        <div class="container">
          <div class="row" *ngIf="selectedItem === 'photos'">
            <ng-container *ngFor="let album of ImageAlbumShown">
              <div class="col-lg-4 col-md-6 mb-4" data-aos="zoom-out-down">
                <div class="gallery-item" style="position: relative; border-radius: 10px; overflow: hidden;">
                  <a [routerLink]="['/imageFolder', album.id]">
                    <div class="image-container">
                      <svg class="loading-spinner" viewBox="0 0 16 18" *ngIf="!imageLoaded"
                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        <path class="path" fill="none" stroke-width="2"
                          d="M7.21487 1.2868C7.88431 0.9044 8.73031 0.9044 9.39974 1.2868L9.40283 1.28856L14.4613 4.20761C15.1684 4.598 15.5746 5.33558 15.5746 6.11465V8.99996V11.8853C15.5746 12.6507 15.1632 13.3848 14.4617 13.7721L9.37973 16.7132C8.71029 17.0956 7.86428 17.0956 7.19485 16.7132L7.19088 16.7109L2.11279 13.772C1.40602 13.3816 1 12.6441 1 11.8653V8.98995V6.11465C1 5.31458 1.44381 4.59039 2.10827 4.21051L7.21487 1.2868Z" />
                      </svg>
                      <div class="image-overlay"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.4); opacity: 0; transition: opacity 0.3s ease;">
                      </div>
                      <img [src]="
                          album.thumbnailLink
                            ? TransformUrl(album.thumbnailLink)
                            : '/assets/img/default_logo.png'
                        " class="card-img-top fit-image" alt="Card Image" (load)="onImageLoad()"
                        style="height: 250px; width: 100%; object-fit: cover; transition: transform 0.3s ease;" />
                    </div>
                  </a>
                </div>
              </div>
            </ng-container>

            <div class="col-md-5"></div>
            <div class="col-md-2">
              <a href="/photo-gallery">
                <button class="btn btn-primary"
                  style="display: block; margin: 0 auto; background-color: #231670; border: none; padding: 12px 30px; font-size: 1.1rem; border-radius: 25px; transition: background-color 0.3s ease; white-space: nowrap;"
                  (mouseover)="hoverIn($event)" (mouseleave)="hoverOut($event)">
                  View All Photos
                </button>
              </a>
            </div>
            <div class="col-md-5"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<!-- Our Gellary Section Ends -->

<section class="team-area pb-100" style="position: relative; z-index: 1; margin-top: 0px; background-color: #005a63;">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      ADMINISTRATIVE BODY
    </h3>
    <hr />

    <div *ngIf="loadingData" class="row gx-2">
      <div class="col-12 col-sm-6 col-lg-3" *ngFor="let i of [1,2,3,4]">
        <div class="single-team-box" aria-hidden="true"
          style="border: 1px solid #ddd; border-radius: 10px; padding-bottom: 10px;">
          <div class="placeholder-glow">
            <span class="placeholder col-12" style="height: 250px;"></span>
          </div>
          <div class="content text-center mt-3 placeholder-glow">
            <h3 class="placeholder col-8" style="height: 20px;"></h3><br>
            <span class="placeholder col-6" style="height: 15px;"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="work-slider owl-carousel owl-theme" [style.height]="loadingData ? '0px' : 'auto'"
      [style.overflow]="loadingData ? 'hidden' : 'visible'" [style.opacity]="loadingData ? '0' : '1'">
      <div class="single-team-box" *ngFor="let item of GBs">
        <div class="image">
          <img [src]="item.ImagePath" [alt]="item.imageAlt" />
        </div>

        <div class="content">
          <h3>{{ item.Name }}</h3>
          <span style="color:white">{{item.InstitutePosition}}</span>
        </div>
      </div>
    </div>
  </div>
</section>